(function () {
  var TOP_VARIANT_ID = 43120802824290;
  var BOTTOM_VARIANT_ID = 43120802857058;

  // Sync field visibility with checkbox state on load.
  // Fixes cases where a checkbox is restored as "checked" by the browser
  // (back/forward navigation, bfcache) without firing a change event,
  // which previously caused the fields (and the embroidery charge) to be
  // silently skipped at Add to Cart time.
  function syncEmbFields() {
    document.querySelectorAll('.emb-toggle').forEach(function (cb) {
      var target = document.getElementById(cb.dataset.target);
      if (target) target.style.display = cb.checked ? 'block' : 'none';
    });
  }
  syncEmbFields();
  window.addEventListener('pageshow', syncEmbFields);

  document.addEventListener('change', function (e) {
    if (e.target.classList && e.target.classList.contains('emb-toggle')) {
      var target = document.getElementById(e.target.dataset.target);
      if (target) target.style.display = e.target.checked ? 'block' : 'none';
    }
  });

  document.addEventListener('click', function (e) {
    if (e.target.classList && e.target.classList.contains('emb-color-swatch')) {
      var group = e.target.closest('.emb-colors');
      group.querySelectorAll('.emb-color-swatch').forEach(function (s) {
        s.classList.remove('selected');
      });
      e.target.classList.add('selected');
    }
  });

  document.addEventListener(
    'click',
    function (e) {
      var submitBtn = e.target.closest('button[type="submit"][name="add"]');
      if (!submitBtn) return;

      var widget = document.querySelector('.embroidery-widget');
      if (!widget) return;

      var form = submitBtn.closest('form');
      if (!form) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      if (submitBtn.dataset.embLock === '1') return;
      submitBtn.dataset.embLock = '1';
      submitBtn.disabled = true;

      var idInput = form.querySelector('[name="id"]');
      var mainVariantId = parseInt(idInput.value, 10);
      var qtyInput = form.querySelector('[name="quantity"]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

      var topFields = widget.querySelector('#emb-top-fields');
      var bottomFields = widget.querySelector('#emb-bottom-fields');
      var topOn = !!(topFields && topFields.style.display === 'block');
      var bottomOn = !!(bottomFields && bottomFields.style.display === 'block');

      var properties = {};
      var items = [];

      if (topOn) {
        var topName = widget.querySelector('[data-prop="Top Embroidery Name"]').value.trim();
        var topDesig = widget.querySelector('[data-prop="Top Embroidery Designation"]').value.trim();
        var topColorEl = widget.querySelector('[data-group="top-color"] .selected');
        properties['Top Embroidery Name'] = topName;
        properties['Top Embroidery Designation'] = topDesig;
        properties['Top Embroidery Color'] = topColorEl ? topColorEl.dataset.color : 'White';
      }
      if (bottomOn) {
        var bottomName = widget.querySelector('[data-prop="Bottom Embroidery Name"]').value.trim();
        var bottomColorEl = widget.querySelector('[data-group="bottom-color"] .selected');
        properties['Bottom Embroidery Name'] = bottomName;
        properties['Bottom Embroidery Color'] = bottomColorEl ? bottomColorEl.dataset.color : 'White';
      }

      items.push({ id: mainVariantId, quantity: qty, properties: properties });
      if (topOn) items.push({ id: TOP_VARIANT_ID, quantity: qty, properties: { _Linked_to: 'Top Embroidery' } });
      if (bottomOn)
        items.push({ id: BOTTOM_VARIANT_ID, quantity: qty, properties: { _Linked_to: 'Bottom Embroidery' } });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (r) {
          if (!r.ok) {
            return r.json().then(function (errBody) {
              throw new Error((errBody && errBody.description) || 'Add to cart failed');
            });
          }
          return r.json();
        })
        .then(function () {
          window.location.href = '/cart';
        })
        .catch(function (err) {
          console.error('Embroidery add-to-cart failed', err);
          alert('Sorry, something went wrong adding this to your cart: ' + err.message);
          submitBtn.disabled = false;
          submitBtn.dataset.embLock = '0';
        });
    },
    true
  );
})();
